const WINDOWS_PRINT_KEY = 'pos_windows_print';

// The dedicated Windows shortcut sets this before login. Its Chrome profile
// supplies kiosk printing; a web page alone cannot disable browser dialogs.
export function initWindowsPrint() {
  const url = new URL(window.location.href);
  if (url.searchParams.get('windowsPrint') === '1') {
    localStorage.setItem(WINDOWS_PRINT_KEY, '1');
    url.searchParams.delete('windowsPrint');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }
}
export const usesWindowsPrinter = () => localStorage.getItem(WINDOWS_PRINT_KEY) === '1';
export const canServerPrint = (settings = {}) => !usesWindowsPrinter()
  && settings.paper !== 'custom'
  && settings.server_print_allowed === true
  && !!settings.eth_ip
  && settings.server_print_target?.ip === settings.eth_ip
  && settings.server_print_target?.port === Number(settings.eth_port || 9100);

export const printerMode = (settings = {}) => {
  if (usesWindowsPrinter()) return 'browser';
  const requested = settings.mode || (settings.eth_ip ? 'ethernet' : 'browser');
  // Old/cached Ethernet settings must never send an unapproved job to the VPS.
  if (requested === 'ethernet') return canServerPrint(settings) ? 'ethernet' : 'browser';
  return requested === 'bluetooth' ? 'bluetooth' : 'browser';
};
